import React, { useEffect, useState } from "react";

import { Container, Grid, Typography } from "@mui/material";

import OrganizationCard from "../../../components/layout/OrganizationCard";
import { handlePagingAll } from "../../../components/api/APIUtilities";
import ListResponsive from "../../../components/other/ListResponsive";
import { AdminTabs } from "../Admin";
import { BCPSquarePlus } from "../../../components/icons/bcp/BCPIcons";

export default function AdminOrganizations(props) {
  const { activeTab, handleTabChange, authContext } = props;

  const [subLoading, setSubLoading] = useState(true);
  const [gameStores, setGameStores] = useState(null);

  useEffect(() => {
    const check = async () => {
      var apiGameStores = await handlePagingAll(`/gamestores`, {
        limit: 100,
        sortAscending: false,
        "expand[]": ["location", "owner"],
      });

      apiGameStores.forEach((apiGameStore) => {
        if (apiGameStore.location) {
          apiGameStore.location.displayLocation = "";
          if (apiGameStore.location.city && apiGameStore.location.city !== "") {
            if (apiGameStore.location.displayLocation !== "") {
              apiGameStore.location.displayLocation += ", ";
            }
            apiGameStore.location.displayLocation += apiGameStore.location.city;
          }
          if (
            apiGameStore.location.state &&
            apiGameStore.location.state !== ""
          ) {
            if (apiGameStore.location.displayLocation !== "") {
              apiGameStore.location.displayLocation += ", ";
            }
            apiGameStore.location.displayLocation +=
              apiGameStore.location.state;
          }
          if (
            apiGameStore.location.country &&
            apiGameStore.location.country !== ""
          ) {
            if (apiGameStore.location.displayLocation !== "") {
              apiGameStore.location.displayLocation += ", ";
            }
            apiGameStore.location.displayLocation +=
              apiGameStore.location.country;
          }
        }
      });
      setGameStores(apiGameStores);
      setSubLoading(false);
    };
    check();
  }, []);

  return (
    <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
      <Grid container sx={{ gap: 2 }}>
        <Grid
          item
          xs={12}
          sx={{
            p: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 1,
            backgroundColor: "background.secondary",
          }}
        >
          <Typography variant="h3">Admin Settings</Typography>

          <AdminTabs
            activeTab={activeTab}
            handleTabChange={handleTabChange}
            authContext={authContext}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            p: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 1,
            backgroundColor: "background.secondary",
          }}
        >
          <ListResponsive
            originalList={subLoading ? null : gameStores}
            doSearch
            doPages
            initialRowsPerPage={24}
            actionButton={{
              props: {
                variant: "contained",
                color: "primary",
                fullWidth: true,
                href: "/organize/organization",
                startIcon: <BCPSquarePlus />,
              },
              label: "New Organization",
            }}
            searchProps={{
              label: "Search Organizations",
              performSearch: (originalList, searchText) => {
                if (!searchText || searchText === "") {
                  return originalList;
                } else {
                  var filteredList = originalList.filter(function (el) {
                    if (el?.name?.toLowerCase().includes(searchText))
                      return true;
                    if (
                      el?.owner?.firstName?.toLowerCase().includes(searchText)
                    )
                      return true;
                    if (el?.owner?.lastName?.toLowerCase().includes(searchText))
                      return true;
                    if (el?.approvalStatus?.toLowerCase().includes(searchText))
                      return true;

                    if (
                      el?.location?.displayLocation
                        ?.toLowerCase()
                        .includes(searchText)
                    )
                      return true;

                    return false;
                  });
                  return filteredList;
                }
              },
            }}
            rowProps={{
              mapFunction: (row, index) => (
                <Grid
                  key={row?.id || index}
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  sx={{ p: 1 }}
                >
                  <OrganizationCard
                    isAdmin
                    organization={row}
                    authContext={authContext}
                    key={row?.id || index}
                    deleteOrganization={(organizationId) => {
                      var newGameStores = [];
                      for (let gamestore of gameStores) {
                        if (gamestore.id !== organizationId) {
                          newGameStores.push(gamestore);
                        }
                      }
                      setGameStores(newGameStores);
                    }}
                    updateOrganization={(organization) => {
                      var newGameStores = [];
                      for (let gamestore of gameStores) {
                        newGameStores.push(
                          gamestore.id === organization.id
                            ? organization
                            : gamestore
                        );
                      }
                      setGameStores(newGameStores);
                    }}
                  />
                </Grid>
              ),
            }}
          />
        </Grid>
      </Grid>
    </Container>
  );
}
